import cn from 'classnames';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { addPackagingData } from '../../../actions/package';
import { addStaff, changeStaff } from '../../../actions/staff';
import PackageApi from '../../../API/shipment/package-api';
import UserApi from '../../../API/user/user-api';
import archive from '../../../assets/media/archive.svg';
import bucket from '../../../assets/media/bucket.svg';
import pencil from '../../../assets/media/icon_pencil.svg';
import qr from '../../../assets/media/icons/qr-code-scan.svg';
import { Column, Row, WhiteBlock } from '../../../components/Basic/Blocks';
import { Button } from '../../../components/Basic/Buttons';
import { Icon } from '../../../components/Basic/Elements';
import { Content } from '../../../components/Basic/Global';
import { Input } from '../../../components/Basic/Inputs';
import { HeaderTitle, Table, TableCell, TableHeader, TableLine } from '../../../components/Basic/Table';
import { H1, H3, Text, TextGrey } from '../../../components/Basic/WrapsStyle';
import AccessContentUserPopUp from '../../../components/Settings/PopUps/AccessContentUser';
import AccessSkladPopUp from '../../../components/Settings/PopUps/AccessSklad';
import AccessUserPopUp from '../../../components/Settings/PopUps/AccessUser';
import PackageMethodPopUp from '../../../components/Settings/PopUps/AddPackageMethod';
import ChangeUserPopUp from '../../../components/Settings/PopUps/ChangeUser';
import ChangeUserPassPopUp from '../../../components/Settings/PopUps/ChangeUserPass';
import CreateUserPopUp from '../../../components/Settings/PopUps/CreateUser';
import DeleteUserPopUp from '../../../components/Settings/PopUps/DeleteUser';
import { ALL_USERS, TO_PROFILE, TYPE_BUTTONS } from '../../../constans';
import { NAVIGATION } from '../../../routers/routes';
import styles from './styles.module.scss';

const width = ['40px', '180px', '80px', '150px', '500px', '500px', '470px', '550px'];

function CommonPage() {
  const dispatch = useDispatch();
  const [popUp, setPopUp] = useState(false);
  const [popUpChange, setChangePopUp] = useState({ show: false, user: {} });
  const [popUpChangePass, setChangePassPopUp] = useState({ show: false, user: {} });

  const [popUpDelete, setDeletePopUp] = useState({ show: false, user: {} });
  const [popUpAccess, setAccessPopUp] = useState({ show: false, user: {} });
  const [popUpAccessSklad, setAccessSkladPopUp] = useState({ show: false, user: {} });

  const [popUpAccessContent, setAccessContentPopUp] = useState({ show: false, user: {} });

  const [popUpMethod, setMethodsPopUp] = useState(false);

  const staff = useSelector((store) => store.staff);
  const user = useSelector((store) => store.user);
  const methods = useSelector((store) => store.packaging);

  const getMethods = async () => {
    await PackageApi.getAll({}).then(r => dispatch(addPackagingData(r.data)))
  };

  const getActivityStatus = (dateLastActivity) => {
    const minutesAgo = moment().diff(dateLastActivity, 'minutes')
    if (minutesAgo < 1) return 'В сети'
    if (minutesAgo >= 1 && minutesAgo < 60) return `${minutesAgo} минут(ы) назад`
    const hoursAgo = Math.round(minutesAgo / 60)
    if (hoursAgo < 24) return `${hoursAgo} час(а) назад`
    const daysAgo = Math.round(hoursAgo / 24)
    return `${daysAgo} дня назад`
  }


  useEffect(() => {
    UserApi.getAllUsers({}).then(r => dispatch(addStaff(r.users)))
  }, []);

  const owner = staff.filter((user) => user.role === 'owner');
  const admin = staff.filter((user) => user.role === 'admin');
  const users = staff.filter((user) => user.role === 'user');
  const bookers = staff.filter((user) => user.role === 'booker');
  const content = staff.filter((user) => user.role === 'content');
  const packer = staff.filter((user) => user.role === 'packer');
  const sorter = staff.filter((user) => user.role === 'sorter');

  const sorted = [...owner, ...admin, ...users, ...bookers, ...content, ...packer, ...sorter].filter(user => !user.archive?.status);

  return (
    <>
      <Content>
        <WhiteBlock style={{ width: '100%', maxWidth: '500px' }}>
          <H3 style={{ marginBottom: '10px' }}>Личные данные</H3>
          <Row>
            <TextGrey>Логин: </TextGrey>
            <Text fontSize={16}>{user.login}</Text>
          </Row>
          <Row>
            <TextGrey>Имя: </TextGrey>
            <Text fontSize={16}>{user.name}</Text>
          </Row>
          <Row>
            <TextGrey>Роль: </TextGrey>
            <Text fontSize={16}>{ALL_USERS[user.role].name}</Text>
          </Row>
        </WhiteBlock>

        <Row style={{ alignItems: 'flex-start' }}>
          <Column>
            <H1>Сотрудники</H1>
            <Button type={TYPE_BUTTONS.BLUE} style={{ marginBottom: '20px' }} onClick={() => setPopUp(true)}>
              Добавить нового сотрудника
            </Button>
            <Table style={{ width: '1600px' }}>
              <TableHeader whiteHeader={true}>
                <HeaderTitle width={width[0]}>№</HeaderTitle>
                <HeaderTitle width={width[1]}>Логин</HeaderTitle>
                <HeaderTitle width={width[3]} centerText>
                  Роль
                </HeaderTitle>
                <HeaderTitle width={width[2]} centerText>
                  Scanner Id
                </HeaderTitle>
                <HeaderTitle width={width[3]} centerText>Состояние в сети</HeaderTitle>
                <HeaderTitle width={width[4]}>Доступы</HeaderTitle>
                <HeaderTitle width={width[6]}>Настройка доступов</HeaderTitle>
                <HeaderTitle width={width[5]} rightText />
              </TableHeader>
              {sorted.map((item, key) => (
                <TableLine key={key}>
                  <TableCell width={width[0]}>{key + 1}</TableCell>
                  <TableCell width={width[1]}>
                    <Column>
                      <Link to={TO_PROFILE(item._id)} className={styles.link}>
                        <div style={{ fontWeight: '600' }}>{item.name}</div>
                      </Link>
                      <TextGrey>{item.login}</TextGrey>
                    </Column>
                  </TableCell>
                  <TableCell width={width[3]} center>
                    <div
                      className={cn(
                        styles.status,
                        ALL_USERS[item.role].name === ALL_USERS.owner.name && styles.sold,
                        ALL_USERS[item.role].name === ALL_USERS.admin.name && styles.sorted,
                        ALL_USERS[item.role].name === ALL_USERS.user.name && styles.pickup,
                        ALL_USERS[item.role].name === ALL_USERS.packer.name && styles.canceled_by_client,
                        ALL_USERS[item.role].name === ALL_USERS.sorter.name && styles.sorted,
                        ALL_USERS[item.role].name === ALL_USERS.content.name && styles.content,
                        ALL_USERS[item.role].name === ALL_USERS.booker.name && styles.booker,
                      )}
                    >
                      {ALL_USERS[item.role].name}
                    </div>
                  </TableCell>
                  <TableCell width={width[2]} center>
                    {item.scanerId}
                  </TableCell>
                  <TableCell width={width[3]} center>
                    {item.date_last_action && getActivityStatus(item.date_last_action)}
                  </TableCell>
                  <TableCell width={width[4]}>
                    <Text style={{ overflowWrap: 'anywhere' }}>
                      {
                        Object.entries(item.accesses || {})
                          .reduce((acc, [serviceName, accessesByService]) => {
                            Object.entries(accessesByService).forEach(([access, hasAccess]) => { if (hasAccess) acc.push(NAVIGATION?.[serviceName]?.routes.find(r => r.path === access)?.name) })
                            return acc
                          }, []).join(', ')
                      }
                    </Text>
                  </TableCell>
                  <TableCell width={width[6]} style={{ alignItems: 'center' }}>
                    <Button
                      type={TYPE_BUTTONS.WHITE}
                      style={{ marginRight: '10px' }}
                      disabled={item.role === 'owner'}
                      onClick={() => setAccessPopUp({ show: true, user: item })}
                    >
                      Доступы
                    </Button>
                    <Button
                      type={TYPE_BUTTONS.WHITE}
                      style={{ marginRight: '10px' }}
                      disabled={item.role === 'owner'}
                      onClick={() => setAccessContentPopUp({ show: true, user: item })}
                    >
                      Контент доступы
                    </Button>
                    <Button
                      type={TYPE_BUTTONS.WHITE}
                      style={{ marginRight: '10px' }}
                      disabled={item.role === 'owner'}
                      onClick={() => setAccessSkladPopUp({ show: true, user: item })}
                    >
                      Доступы склада
                    </Button>
                  </TableCell>
                  <TableCell width={width[4]} style={{ alignItems: 'center' }}>
                    <Button
                      type={TYPE_BUTTONS.WHITE}
                      onClick={async () => {
                        await UserApi.getAuthBarcode({ data: { login: item.login }, options: { download: true } })
                      }}
                      style={{ padding: 0, marginRight: '15px' }}
                    >
                      <Icon src={qr} width="35px" />
                    </Button>

                    <Button onClick={() => setChangePopUp({ show: true, user: item })}>
                      <Icon src={pencil} width="18px" style={{ marginRight: '15px' }} />
                    </Button>

                    <Button
                      type={TYPE_BUTTONS.WHITE}
                      style={{ marginRight: '10px' }}
                      onClick={() => setChangePassPopUp({ show: true, user: item })}
                    >
                      Изменить пароль
                    </Button>
                    <Button
                      onClick={() =>
                        UserApi.changeUser({ data: { login: item.login, data: { ...item, archive: { status: !item.archive?.status, date: new Date() } } } })
                          .then((r) => {
                            dispatch(changeStaff(r.data.login, r.data));
                          })
                      }
                      disabled={item.role === 'owner'}
                      style={{ marginLeft: '20px' }}
                    >
                      <Icon src={archive} width="20px" height={'25px'} style={{ marginRight: '30px' }} />
                    </Button>
                    <Button
                      onClick={() => setDeletePopUp({ show: true, user: item })}
                      disabled={item.role === 'owner'}
                      style={{ marginLeft: '20px' }}
                    >
                      <Icon src={bucket} width="18px" height={'20px'} style={{ marginRight: '15px' }} />
                    </Button>
                  </TableCell>
                </TableLine>
              ))}
            </Table>
          </Column>
          <Column style={{ marginLeft: '15px' }}>
            <H1>Способы упаковки</H1>
            <Button type={TYPE_BUTTONS.BLUE} style={{ marginBottom: '20px' }} onClick={() => setMethodsPopUp(true)}>
              Добавить новый способ
            </Button>
            <Table style={{ width: '400px' }}>
              <TableHeader whiteHeader={true}>
                <HeaderTitle width={width[0]}>№</HeaderTitle>
                <HeaderTitle width={width[1]}>Способ</HeaderTitle>
                <HeaderTitle width={width[2]}>Формула</HeaderTitle>
                <HeaderTitle width={width[2]}>Литры без надбавки</HeaderTitle>
                <HeaderTitle width={width[2]}>Надбавка за объем</HeaderTitle>
                <HeaderTitle width={width[2]}>Макс. ставка</HeaderTitle>
                <HeaderTitle width={width[2]}>Ставка</HeaderTitle>
                <HeaderTitle width={width[0]} />
              </TableHeader>
              {methods.map((item, key) => (
                <TableLine key={key}>
                  <TableCell width={width[0]}>{key + 1}</TableCell>
                  <TableCell width={width[1]}>
                    <Input
                      value={item.method}
                      onBlur={(value) => PackageApi.changePackageMethod({ data: { method: item._id, field: 'method', value } })}
                    />
                  </TableCell>
                  <TableCell width={width[2]}>
                    <Input
                      value={item.formula}
                      onBlur={(value) => PackageApi.changePackageMethod({ data: { method: item._id, field: 'formula', value } })}
                    />
                  </TableCell>
                  <TableCell width={width[2]}>
                    <Input
                      value={item.base_liter}
                      onBlur={(value) => PackageApi.changePackageMethod({ data: { method: item._id, field: 'base_liter', value } })}
                    />
                  </TableCell>
                  <TableCell width={width[2]}>
                    <Input
                      value={item.step_liter_pay}
                      onBlur={(value) => PackageApi.changePackageMethod({ data: { method: item._id, field: 'step_liter_pay', value } })}
                    />
                  </TableCell>
                  <TableCell width={width[2]}>
                    <Input
                      value={item.max_pay}
                      onBlur={(value) => PackageApi.changePackageMethod({ data: { method: item._id, field: 'max_pay', value } })}
                    />
                  </TableCell>
                  <TableCell width={width[2]}>
                    <Input
                      value={item.pay}
                      onBlur={(value) => PackageApi.changePackageMethod({ data: { method: item._id, field: 'pay', value } })}
                      center
                    />
                  </TableCell>
                  <TableCell width={width[0]} center>
                    <Button
                      onClick={async () => {
                        await PackageApi.delete({ data: { method: item._id } })
                        getMethods();
                      }}
                      disabled={item.role === 'owner'}
                    >
                      <Icon src={bucket} width="18px" height={'20px'} />
                    </Button>
                  </TableCell>
                </TableLine>
              ))}
            </Table>
          </Column>
        </Row>
      </Content >
      {popUp && <CreateUserPopUp close={() => setPopUp(false)} />
      }
      {
        popUpMethod && (
          <PackageMethodPopUp
            close={() => {
              setMethodsPopUp(false);
              getMethods();
            }}
          />
        )
      }

      {
        popUpChange.show && (
          <ChangeUserPopUp user={popUpChange.user} close={() => setChangePopUp({ show: false, user: {} })} />
        )
      }
      {
        popUpChangePass.show && (
          <ChangeUserPassPopUp user={popUpChangePass.user} close={() => setChangePassPopUp({ show: false, user: {} })} />
        )
      }

      {
        popUpDelete.show && (
          <DeleteUserPopUp user={popUpDelete.user} close={() => setDeletePopUp({ show: false, user: {} })} />
        )
      }

      {
        popUpAccess.show && (
          <AccessUserPopUp user={popUpAccess.user} close={() => setAccessPopUp({ show: false, user: {} })} />
        )
      }
      {
        popUpAccessSklad.show && (
          <AccessSkladPopUp user={popUpAccessSklad.user} close={() => setAccessSkladPopUp({ show: false, user: {} })} />
        )
      }

      {
        popUpAccessContent.show && (
          <AccessContentUserPopUp
            user={popUpAccessContent.user}
            close={() => setAccessContentPopUp({ show: false, user: {} })}
          />
        )
      }
    </>
  );
}

export default CommonPage;
